// Bloco recolhível de Preferências (pedido do dono, 29/09/2026: "colapsar"
// para a página ficar organizada). A linha do título fica sempre à vista —
// ícone, título, resumo e, quando o bloco tem, o switch principal (dá para
// ligar/desligar sem abrir). Clicar no título abre e fecha o conteúdo; começa
// fechado. O conteúdo NUNCA é desmontado ao fechar (só fica escondido): o
// bloco da CLEO salva sozinho 800 ms depois da última mudança e perderia a
// digitação se fosse desmontado.
import { ChevronDown } from "lucide-react";
import { useState } from "react";

import { Skeleton } from "@/components/ui/skeleton";

// `carregando` (25/10/2026): até a config do bloco chegar, o resumo e a chave
// aparecem piscando em cinza — antes a chave nascia DESLIGADA e o lojista podia
// achar que a configuração tinha sumido.
export default function BlocoRecolhivel({ e2e, icone: Icone, titulo, resumo, controle, children, abertoInicial = false, carregando = false }) {
  const [aberto, setAberto] = useState(abertoInicial);
  return (
    <div className="rounded-2xl border bg-card" data-e2e={e2e} data-aberto={aberto ? "1" : "0"}>
      <div className="flex items-center gap-3 p-4">
        <button type="button" onClick={() => setAberto((a) => !a)} aria-expanded={aberto} data-e2e={`${e2e}-abrir`}
          className="flex items-center gap-3 min-w-0 flex-1 text-left">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0"><Icone className="w-5 h-5 text-primary" /></div>
          <div className="min-w-0 flex-1">
            <h3 className="font-semibold">{titulo}</h3>
            {carregando ? <Skeleton className="h-3.5 w-48 max-w-full mt-1.5" aria-label="Carregando" />
              : resumo && <p className="text-sm text-muted-foreground truncate" data-e2e={`${e2e}-resumo`}>{resumo}</p>}
          </div>
          <ChevronDown className={`w-5 h-5 text-muted-foreground shrink-0 transition-transform ${aberto ? "rotate-180" : ""}`} />
        </button>
        {carregando && controle !== undefined ? <Skeleton className="h-6 w-11 rounded-full shrink-0" />
          : controle && <div className="shrink-0">{controle}</div>}
      </div>
      <div className={aberto ? "border-t px-4 pb-4 pt-3" : "hidden"}>{children}</div>
    </div>
  );
}
